import React from "react";

function Stage4() {
  return (
    <>
      {/* <div className="stylesheetpage-container">
        <div className="stylesheetpage-box"> */}
          <h2 className="stylesheetpage-title">Secondary Key Stage 4 (IGCSE)</h2>
          <p className="stylesheetpage-text">
            <strong>IGCSE</strong>
          </p>
          <p className="stylesheetpage-text">
            <strong>GRADES 9 and 10</strong>
          </p>
          <p className="stylesheetpage-text">
            ACE follows the Cambridge Secondary 2 curricula which are typically
            for students aged 14-16 years. This builds on the foundations of
            Cambridge Secondary 1, and supports the Academy using student-centred
            and enquiry-based approach to learning. ACE offers Cambridge IGCSE; a
            globally recognized qualification of Cambridge International
            Examination. Cambridge Secondary 2 provides excellent progression to
            the next stage of Cambridge International Education – Cambridge
            Advanced for 16-19 years – as well as other progression routes.
            Cambridge IGCSE Syllabus for each subject is covered in two years
            Grade 9 and Grade 10; other than Pakistan Studies, Urdu as a Second
            Language and Islamiyat which are initiated in Grade 8 and Completed in
            Grade 9.
          </p>
          <p className="stylesheetpage-text">
            Cambridge IGCSE encourages learner-centred and enquiry-based approach
            to learning. It develops student skills in creative thinking, enquiry
            and problem-solving; providing students excellent preparation for the
            next stage in their education. We build a core curriculum, extend /
            design it to suit our students and introduce cross-curricular
            perspectives. Clearly defined learning-outcomes and content mean
            Cambridge IGCSE is not only compatible with other curricula,
            nationally and internationally, but relevant and sensitive to
            different needs and cultures.
          </p>
          <p className="stylesheetpage-text">
            Cambridge IGCSE develops student knowledge, understanding and skills
            in:
          </p>
          <ul>
            <li>Subject content</li>
            <li>
              Applying knowledge and understanding to familiar and new situations
            </li>
            <li>Intellectual enquiry</li>
            <li>Flexibility and responsiveness to change</li>
            <li>Working and communicating in English</li>
            <li>Influencing outcomes</li>
            <li>Cultural awareness</li>
          </ul>
          <p className="stylesheetpage-text">&nbsp;</p>
          <p className="stylesheetpage-text">
            <strong>IGCSE SUBJECTS</strong>
          </p>
          <p className="stylesheetpage-text">
            ACE is offering below mentioned subjects in IGCSE. Students MUST take
            a minimum of EIGHT subjects at this level.
          </p>
          <ol>
            <li>
              <strong> Compulsory Subjects for All IGCSE Students:-</strong>
            </li>
          </ol>
          <p className="stylesheetpage-text">English – Second Language 0510</p>
          <p className="stylesheetpage-text">Mathematics 0580</p>
          <ol>
            <li>
              <strong>
                {" "}
                Compulsory Subjects only for Pakistani and Dual National students
                who spend more than 03 years in Pakistan by the time they complete
                A Level:
              </strong>
            </li>
          </ol>
          <p className="stylesheetpage-text">Pakistan Studies 0448</p>
          <p className="stylesheetpage-text">Islamiyat 0493</p>
          <p className="stylesheetpage-text">Urdu – Second Language 3248</p>
          <p className="stylesheetpage-text">
            (N.B. Continued from Grade 8; students will write the final CIE IGCSE
            Examination for the stated 03 subjects at the end of Grade 9.)
          </p>
          <p className="stylesheetpage-text">
            <strong>Major Subjects </strong>
          </p>
          <p className="stylesheetpage-text">
            Students will be required to choose ONE of the following groups for
            Major Subjects:
          </p>
          <table
            style={{
              border: "1px solid #dadada",
              borderCollapse: "collapse",
              borderSpacing: "0",
              fontSize: "14px",
              lineHeight: "2",
              margin: "0 0 20px",
              width: "100%",
            }}
          >
            <tbody>
              <tr>
                <th>GROUP 1</th>
                <th>GROUP 2</th>
                <th>GROUP 3</th>
              </tr>
              <tr>
                <td>Accounting 0452</td>
                <td>Biology 0610</td>
                <td>ICT 0417</td>
              </tr>
              <tr>
                <td>Business Studies 0450</td>
                <td>Chemistry 0620</td>
                <td>Chemistry 0620</td>
              </tr>
              <tr>
                <td>Economics 0455</td>
                <td>Physics 0625</td>
                <td>Physics 0625</td>
              </tr>
            </tbody>
          </table>
          <p className="stylesheetpage-text">
            <strong> Compulsory Subjects at ACE for Foreign Students:</strong>
          </p>
          <p className="stylesheetpage-text">
            <strong>
              (Foreign Students MUST choose the below mentioned subjects in lieu
              IF NOT opting for{" "}
            </strong>
          </p>
          <p className="stylesheetpage-text">
            <strong> Urdu and Pakistan Studies.) </strong>
          </p>
          <p className="stylesheetpage-text">
            <strong> </strong>
          </p>
          <p className="stylesheetpage-text">
            Art and Design 0400 (in lieu of Urdu as a Second Language)
          </p>
          <p className="stylesheetpage-text">
            Thinking Skills (in lieu of Pakistan Studies)
          </p>
        {/* </div>
      </div> */}
    </>
  );
}

export default Stage4;
